import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
	name: 'managementCompany',
	initialState: {
		id: null,
		name: ''
	},
	reducers: {
		setManagementCompany: (state, action) => ({
			id: action.payload.id,
			name: action.payload.name
		})
	}
});

export const { setManagementCompany } = slice.actions;
export const managementCompany = (state) => state.managementCompany;

export default slice.reducer;
